<template>
  <b-card class="border-primary">
    <!-- <h4 class="mb-1">معلومات المنظمة</h4> -->

    <div
      style="gap: 15px"
      class="d-flex align-items-center justify-content-start"
    >
      <b-avatar
        variant="transprent"
        class="shadow-sm p-25"
        :src="ngo.logo"
        size="90px"
        rounded
      />

      <ul class="list-unstyled mr-1">
        <li>
          <h3>
            <b-link @click="onLinkClicked(ngo.id)" class="align-middle">{{
              ngo.name_ar
            }}</b-link>
          </h3>
        </li>
        <li class="my-25">
          <span v-if="ngo.r_classifications.length > 0" class="align-middle">
            التصنيفات :
            {{ ngo.r_classifications.join(" , ") }}</span
          >
          <span v-else class="align-middle"> بدون تصنيف </span>
        </li>

        <li class="my-25">
          <span class="align-middle">
            الشكل القانوني :
            {{ ngo.legalForm.name_ar }}</span
          >
        </li>
      </ul>
    </div>
    <!-- <b-button
        v-ripple.400="'rgba(255, 255, 255, 0.15)'"
        variant="primary"
        block
      >
        عرض المنظمة
      </b-button> -->
  </b-card>
</template>

<script>
import {
  BCard,
  BAvatar,
  BCardHeader,
  BCardBody,
  BBadge,
  BButton,
  BLink,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  props: {
    ngo: Object,
  },
  components: {
    BCard,
    BAvatar,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
    BLink,
  },
  methods: {
    onLinkClicked(id) {
      localStorage.setItem("ni", id);
      this.$router.push({ name: "ngo-profile" });
    },
  },
};
</script>

<style></style>
